'use strict';

module.exports = [
// type
require('./ResultSet')];


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/type/resultset/index.js
// module id = U+o+
// module chunks = 0